
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing-publications",
      function () {
        return require("private-next-pages/listing-publications/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing-publications"])
      });
    }
  